module.exports = __webpack_public_path__ + "static/media/course_notes.8330cbcb.png";